import { Box, makeStyles, Typography } from '@material-ui/core';
import cn from 'classnames';
import React from 'react';
import { TranquiTheme } from '../../containers/App/theme';
import { CssSpreadType } from '../../utils/css-spread-type';

interface TitleProps {
  title: string;
  subtitle: string;
}

export const Title: React.FC<TitleProps> = ({ title, subtitle }) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  return (
    <Box className={cn('mb-4')}>
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.subtitle} variant="h3">{subtitle}</Typography>
    </Box>
  );
};

const useStyles = makeStyles((theme: TranquiTheme) => ({
  root: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  },
  title: {
    ...(theme.typography.capitalize as CssSpreadType),
    color: theme.palette.text5.main,
  },
  subtitle: {
    color: theme.palette.indigo.main,
  },
}));
